const getters = {
  id: (state: any) => state.id,
  data: (state: any) => state.data
}

export default getters
